import { render, staticRenderFns } from "./regInfo.vue?vue&type=template&id=8b1d036a&scoped=true"
import script from "./regInfo.vue?vue&type=script&lang=js"
export * from "./regInfo.vue?vue&type=script&lang=js"
import style0 from "./regInfo.vue?vue&type=style&index=0&id=8b1d036a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1d036a",
  null
  
)

export default component.exports